import Http from '../Http';

export class CuentaBancariaService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`cuenta-bancaria/filter?${params.toString()}`);
      return res.data.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`cuenta-bancaria/delete`, row);
      return !res.error;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`cuenta-bancaria/one/${id}`);
      return res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async guardar(data: Record<string, any>) {
    try {
      const res = await Http.post('cuenta-bancaria/save', data);
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al guardar la cuenta bancaria' };
    }
  }

  static async obtenerBancos() {
    try {
      const res = await Http.get('banco/all');
      if (res && !res.error && Array.isArray(res.data)) {
        return res.data.map((item: any) => ({
          value: item.id,
          label: item.banco_nombre || item.banco,
        }));
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
